import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'descProperty' })
export class DescPropertyPipe implements PipeTransform {
  transform(obj: any): any {
    if (!obj) return '';
    const key = Object.keys(obj).find((k) => k.toLowerCase().includes('desc'));
    return key ? obj[key] : obj;
  }
}
